export default __webpack_public_path__ + "static/media/Nioicon.2223262e.ttf";